import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class TicketedEvent extends ODataSelect
{
    public Node_Id = 0;
    public Ticketed_Event_Id = "";
    public Booking_Id = "";
    public Event_Title = "";
    public Event_Short_Description = "";
    public Event_Description = "";
    public WebSite_URL = "";
    public ImageURI = "";
    public Event_Date = DateHelper.null();
    public Event_Start_DateTime = DateHelper.null();
    public Event_End_DateTime = DateHelper.null();
    public Event_Capacity = 0;
    public IsWaitingList_Allowed = false;
    public Invite_Permission = "";
    public Event_Status = "";
    public Space_Id = "";

    public init(response: any, nodeId: number): TicketedEvent
    {
        super.init(response, nodeId);
        this.Event_Date = DateHelper.fromIsoByNode(response.Event_Date, nodeId);
        this.Event_Start_DateTime = DateHelper.fromIsoByNode(response.Event_Start_DateTime, nodeId);
        this.Event_End_DateTime = DateHelper.fromIsoByNode(response.Event_End_DateTime, nodeId);
        this.IsWaitingList_Allowed = response.IsWaitingList_Allowed === 1 ? true : false;

        return this;
    }

}


export class BookingDetails extends ODataSelect
{
    public Booking_Id = "";
    public Booking_Party_Count = 0;
    public Booking_Parties: BookingParty[] = [];

}


export type BookingParty = {
    Record_Id: string;
    Booking_Participant_Email: string;
    Booking_Participant_Name: string;
    Booking_Participant_Organisation: string;
    Booking_Resource_Id: string;
    Booking_Visitor: boolean;
    Booking_Participant_Type: number;
};



export interface IMyBooking
{
    Booking_Series_Id: string;
    Record_Id: string;
    Booking_Id: string;
    Booking_Start: string;
    Booking_End: string;
    Node_Id: number;
    Booking_Resource_Id: string;
    Booking_Participant_Email: string;
    Booking_Participant_Name: string;
    Booking_Participant_Organisation: string;
    Booking_Participant_Type: number;
    Booking_Participant_CheckedIn: number;
    Booking_Status: string;
    Booking_Name: string;
    Space_Id: string;
    Space_Name: string;
    Space_Name_Label: string;
    Booking_Early_Checkin: string;
    Booking_Attendance: number;
    Booking_IsVisitor: number;
    Booking_IsApproved: number;
    Booking_Participant_Status: string;
}

export class BookingParties extends ODataSelect
{
    public Booking_Participant_Status = "";
    public Booking_Participant_Type = "";
    public Booking_Id = "";
    public Node_Id = 0;
    public Booking_Participant_Email = "";
    public CreatedBy = "";
    public EventId = "";
}